module.exports = __webpack_public_path__ + "static/media/foodprint_app1.d621e368.jpg";